import { FC } from "react"
import { Mail } from "lucide-react"
import { SubscriptionEmailLog } from "../../../../../../types"
import Badge from "../../../../badge"
import { Button } from "../../../../buttons"
import { formatDateTimeFromTimestamp } from "../../../../../utils"

interface Props {
  log: SubscriptionEmailLog
  onSelect: (id: string) => void
}

const EngagementEmailLog: FC<Props> = ({ log, onSelect }) => {
  if (!log) return null

  const { status, timestamp, email_id } = log

  return (
    <div className="flex items-center justify-between py-4 max-w-xl">
      <div className="flex items-center">
        <div className="rounded-full bg-neutral-500 p-3">
          <Mail color="#fff" />
        </div>
        <div className="ml-4">
          {email_id ? (
            <Button
              className="border-none"
              paddingOff
              onClick={() => onSelect(email_id)}
            >
              <span className="font-bold transition-colors text-base border-dashed border-neutral-400 border-b hover:text-primary-500">
                Rate alert
              </span>
            </Button>
          ) : (
            <span className="font-bold">Rate alert</span>
          )}
          &nbsp;sent to lead
          <span className="ml-2">
            {status === "0" && <Badge.Info>Unopened</Badge.Info>}
            {status === "1" && <Badge.Info>Sent</Badge.Info>}
            {status === "2" && <Badge.Danger>Opened</Badge.Danger>}
            {status === "3" && <Badge.Success>Clicked</Badge.Success>}
          </span>
        </div>
      </div>

      <div className="text-neutral-400">
        {formatDateTimeFromTimestamp(timestamp, "LL/dd/yyyy 'at' hh:mm:ss a")}
      </div>
    </div>
  )
}

export default EngagementEmailLog
